import { QueryKeys, useCustomQuery } from './index';
import Config from '../../config';
import { BookToTaxCode } from '../../administration/clientAdministrationPage/types';

export const useBookToTaxCodes = ({ periodName }: { periodName: string }) =>
  useCustomQuery<BookToTaxCode[]>(
    [QueryKeys.bookToTaxCodes.BookToTaxCodes, { periodName }],
    {
      url: Config.endpoints.FETCH_BOOK_TO_TAX_CODE_DESCRIPTIONS
        .replace(/:periodName/, periodName),
      errorMessage: 'Fetching book to tax codes failed',
      defaultData: [],
      enabled: Boolean(periodName),
    }
  );

